export default __webpack_public_path__ + "static/media/mortgage.33e4345a.png";